var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-header"},[_vm._v("Dashboard "),_c('small',[_vm._v("Some charts and overview TBD")])])])}]

export { render, staticRenderFns }